import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Lightbox from '../components/Lightbox';
import BrandingSection from '../components/BrandingSection';
import TestimonialsSection from '../components/TestimonialsSection';
import { imageUrl } from '../lib/images';

export default function HomePage() {
  const heroSlides = [
    {
      image: '/_assets/472331762-1068515591958554-2413136772439242105-n.jpg',
      alt: 'Stemningsfuldt bryllupsportræt ved havet i solnedgang',
      label: 'Bryllupsfotografering',
    },
    {
      image: '/_assets/467843501-1084374129755746-8742697337945456892-n.jpg',
      alt: 'Landevejsrytter i høj fart i svinget',
      label: 'Cykelløb & Sportsaction',
    },
    {
      image: '/_assets/75513566-168614701331698-9032259809111210225-n.jpg',
      alt: 'Fejring, fællesskab og stemning til event',
      label: 'Events & Fejringer',
    },
    {
      image: '/_assets/469269727-1092454198947739-5094198924173448864-n.jpg',
      alt: 'Nærværende og autentisk bryllupsfotografi i grønne omgivelser',
      label: 'Autentiske øjeblikke',
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, [heroSlides.length]);

  // Gallery filtering state
  const [galleryCategory, setGalleryCategory] = useState('alle');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const filterCategories = [
    { key: 'alle', label: 'Alle' },
    { key: 'bryllupper', label: 'Bryllupper' },
    { key: 'cykelloeb', label: 'Cykelløb' },
    { key: 'events', label: 'Events & Erhverv' },
    { key: 'familie', label: 'Familiefotografering' },
  ];

  const allPortfolioItems = [
    {
      id: 'bryllup-1',
      image: '/_assets/472331762-1068515591958554-2413136772439242105-n.jpg',
      title: 'Bryllup på stranden',
      category: 'bryllupper',
      categoryLabel: 'Bryllup',
    },
    {
      id: 'cykel-1',
      image: '/_assets/467843501-1084374129755746-8742697337945456892-n.jpg',
      title: 'Feltet i fuld fart',
      category: 'cykelloeb',
      categoryLabel: 'Cykelløb',
    },
    {
      id: 'familie-1',
      image: '/_assets/122139316-196386581887843-7973893422891536185-n.jpg',
      title: 'Leg og glæde i vandpytten',
      category: 'familie',
      categoryLabel: 'Familie',
    },
    {
      id: 'event-1',
      image: '/_assets/75513566-168614701331698-9032259809111210225-n.jpg',
      title: 'Fejring og fællesskab',
      category: 'events',
      categoryLabel: 'Events',
    },
    {
      id: 'bryllup-2',
      image: '/_assets/469269727-1092454198947739-5094198924173448864-n.jpg',
      title: 'Hånd i hånd i naturen',
      category: 'bryllupper',
      categoryLabel: 'Bryllup',
    },
    {
      id: 'cykel-2',
      image: '/_assets/115820782-172952827564552-2790911280586450986-n.jpg',
      title: 'Landevejsfeltet',
      category: 'cykelloeb',
      categoryLabel: 'Cykelløb',
    },
    {
      id: 'event-2',
      image: '/_assets/142299669-247059033487264-5481047819933199986-n.jpg',
      title: 'Konference og netværk',
      category: 'events',
      categoryLabel: 'Events',
    },
    {
      id: 'cykel-3',
      image: '/_assets/115803630-172952807564554-3070980139574409914-n.jpg',
      title: 'Holdånd og sammenhold',
      category: 'cykelloeb',
      categoryLabel: 'Cykelløb',
    },
    {
      id: 'bryllup-3',
      image: '/_assets/468821663-1092454292281063-1944310555028978061-n.jpg',
      title: 'Det uventede øjeblik',
      category: 'bryllupper',
      categoryLabel: 'Bryllup',
    },
    {
      id: 'familie-2',
      image: '/_assets/482221143-1118484233628356-4166053169173591826-n.jpg',
      title: 'Børnelatter og nærvær',
      category: 'familie',
      categoryLabel: 'Familie',
    },
    {
      id: 'event-3',
      image: '/_assets/166714167-283183176541516-3142839106080478528-n.jpg',
      title: 'Træning og energi',
      category: 'events',
      categoryLabel: 'Events',
    },
  ];

  const filteredPortfolio =
    galleryCategory === 'alle'
      ? allPortfolioItems
      : allPortfolioItems.filter((item) => item.category === galleryCategory);

  const handleOpenLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };
  const categories = [
    {
      to: '/branding',
      title: 'Branding & Markedsføring',
      badge: 'Fokus · Foto, Video & Content',
      description:
        'Styrk jeres synlighed med professionelt foto og video. Skræddersyede pakker og månedligt content til caféer, butikker og virksomheder.',
      image: '/_assets/142299669-247059033487264-5481047819933199986-n.jpg',
      linkText: 'Se branding & priser',
    },
    {
      to: '/bryllupper',
      title: 'Bryllupper',
      badge: 'Foto & Video · Pakker',
      description:
        'De store følelser og de små, uerstattelige øjeblikke. Fra forberedelse og vielse til de intime portrætter og brudevalsen.',
      image: '/_assets/472331762-1068515591958554-2413136772439242105-n.jpg',
      linkText: 'Se bryllupper & pakker',
    },
    {
      to: '/cykelloeb',
      title: 'Cykelløb',
      badge: 'Sport & Action',
      description:
        'Fart, intensitet, smerte og eufori. Rytternes fokus, feltets dynamik og den rå stemning på asfalten.',
      image: '/_assets/115820782-172952827564552-2790911280586450986-n.jpg',
      linkText: 'Se cykelbilleder',
    },
    {
      to: '/events',
      title: 'Events & Erhverv',
      badge: 'Dokumentation & SoMe',
      description:
        'Levende dokumentation af jeres arrangement. Visuelt materiale til markedsføring, sociale medier og presse.',
      image: '/_assets/75513566-168614701331698-9032259809111210225-n.jpg',
      linkText: 'Se eventmateriale',
    },
    {
      to: '/familiefotografering',
      title: 'Familiefotografering',
      badge: 'Nærvær & Relationer',
      description:
        'Hjemme hos jer selv eller ude i den fri natur. Ægte smil og naturlige øjeblikke uden stive positurer.',
      image: '/_assets/122139316-196386581887843-7973893422891536185-n.jpg',
      linkText: 'Se familiebilleder',
    },
  ];

  return (
    <>
      <SEO
        title="Lunde Media"
        description="Lunde Media v/ Michael – Professionel fotograf og videograf med fokus på storytelling, følelser, nærvær og ægte øjeblikke inden for bryllupper, sport, events og familier."
      />

      {/* Hero Section (Atmospheric Photography Slider with Light/Balanced Overlay) */}
      <section className="relative min-h-[92vh] sm:min-h-[82vh] md:min-h-[75vh] flex items-center justify-center pt-32 pb-20 sm:pt-28 sm:pb-16 overflow-hidden">
        {/* Background Image Carousel with soft photographic overlay (not too dark) */}
        <div className="absolute inset-0 z-0">
          {heroSlides.map((slide, index) => {
            const isActive = index === currentSlide;
            return (
              <div
                key={slide.image}
                className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                  isActive ? 'opacity-100' : 'opacity-0 pointer-events-none'
                }`}
              >
                <img
                  src={imageUrl(slide.image, 'width=1920,quality=85,format=auto')}
                  alt={slide.alt}
                  className="w-full h-full object-cover object-center transform scale-105 transition-transform duration-7000 ease-out"
                />
              </div>
            );
          })}

          {/* Balanced soft overlay: Let the photograph breathe without being dark or muddy */}
          <div className="absolute inset-0 bg-stone-900/35" />
          <div className="absolute inset-0 bg-gradient-to-t from-stone-950/70 via-stone-900/20 to-stone-900/30" />
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-8 text-center space-y-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-sans font-semibold text-white tracking-tight leading-[1.1] max-w-3xl mx-auto drop-shadow-sm">
            Billeder med nærvær, stemning & historie
          </h1>

          <p className="text-base sm:text-lg text-stone-100 font-sans max-w-xl mx-auto leading-relaxed font-normal drop-shadow-sm">
            Jeg fanger de øjeblikke, mennesker og detaljer, der fortæller historien om dig, din virksomhed eller dit arrangement.
          </p>

          <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/kontakt"
              className="cta-btn w-full sm:w-auto inline-flex items-center justify-center px-7 py-3 bg-white hover:bg-stone-100 text-[#0C0C0D] font-semibold text-sm sm:text-base tracking-wide transition-all shadow-xl hover:shadow-2xl"
            >
              Start en dialog
            </Link>
            <Link
              to="/bryllupper"
              className="cta-btn w-full sm:w-auto inline-flex items-center justify-center px-7 py-3 bg-transparent hover:bg-transparent text-white font-medium text-sm sm:text-base tracking-wide transition-all border border-white"
            >
              Se bryllupspakker
            </Link>
          </div>
        </div>
      </section>

      {/* Light Editorial Section (Verbatim Scraped Text & Brand Manifest) */}
      <section className="py-12 sm:py-14 md:py-16 bg-white text-[#141416] relative border-y border-zinc-200 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-8 relative">
          <div className="relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
            {/* Left Column: Heading & Highlight */}
            <div className="lg:col-span-5 space-y-6">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-[#141416] leading-[1.15] tracking-tight">
                Når du booker Lunde Media som fotograf eller videograf, får du ikke bare en, der trykker på en knap.
              </h2>

              <div className="pt-2">
                <div className="py-2">
                  <p className="text-base sm:text-lg font-serif italic text-[#141416] leading-snug">
                    "Lunde Media – jeg fanger øjeblikket, fortæller historien og giver dig billeder, du har lyst til at vise frem."
                  </p>
                  <div className="mt-3 text-xs uppercase tracking-widest font-semibold text-zinc-500">
                    — Michael, Fotograf & Videograf
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Editorial Body Text */}
            <div className="lg:col-span-7 space-y-5 text-[#3A3836] text-base sm:text-lg leading-relaxed font-sans">
              <p className="text-xl sm:text-2xl font-medium text-[#141416] leading-snug">
                Du får en fotograf, der går tæt på og fanger de øjeblikke, mennesker og detaljer, der fortæller historien om dig, din virksomhed eller dit arrangement.
              </p>

              <p>
                Mit fokus er altid autentiske billeder og levende fortællinger, hvor mennesker og stemning er i centrum – med en professionel, afslappet og nærværende tilgang.
              </p>

              <div className="pt-4 flex items-center gap-4">
                <Link
                  to="/kontakt"
                  className="cta-btn inline-flex items-center justify-center px-7 py-3.5 bg-[#141416] hover:bg-[#28282E] text-white font-medium text-sm tracking-wide transition-all shadow-md"
                >
                  Tag en uforpligtende snak
                </Link>
                <a
                  href="tel:26368306"
                  className="inline-flex items-center gap-2 text-sm font-medium text-[#141416] hover:text-black transition-colors py-2"
                >
                  <i className="fa-solid fa-phone text-xs text-[#141416]" aria-hidden="true" />
                  <span className="whitespace-nowrap">26 36 83 06</span>
                </a>
              </div>
            </div>
          </div>
          </div>
        </div>
      </section>

      {/* Branding & Marketing for Cafés, Restaurants and Businesses (Høj prioritet lige efter intro) */}
      <BrandingSection compact={true} />

      {/* 4 Core Categories Grid (Refined Light Gray Surface) */}
      <section className="py-24 md:py-32 bg-[#F3F4F6] text-[#141416]">
        <div className="max-w-7xl mx-auto px-6 md:px-8 flex flex-col">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 md:mb-16 gap-6">
            <div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-medium text-[#141416] tracking-tight">
                Hvad kan jeg hjælpe dig med?
              </h2>
            </div>
            <p className="text-zinc-600 text-sm md:text-base max-w-md font-sans">
              Uanset om det handler om jeres største livsbegivenhed, sportens intensitet eller jeres virksomhed, tilpasser jeg opgaven 100% til jeres behov.
            </p>
          </div>

          {/* Featured Storytelling Banner (På mobil placeret lige under teksten, på md+ efter kategorierne) */}
          <section
            aria-label="Storytelling banner"
            className="md:order-3 mb-10 md:mb-0 md:mt-8 bg-[#0F0F11] text-white relative overflow-hidden border border-stone-800 shadow-xl py-7 sm:py-8 px-6 sm:px-8 md:px-10"
          >
            {/* Subtil baggrundseffekt */}
            <div className="absolute inset-0 opacity-15 pointer-events-none">
              <img
                src={imageUrl(
                  '/_assets/472331762-1068515591958554-2413136772439242105-n.jpg',
                  'width=1200,quality=60,format=auto'
                )}
                alt=""
                className="w-full h-full object-cover blur-md scale-105"
                aria-hidden="true"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#0F0F11] via-[#0F0F11]/90 to-[#0F0F11]" />
            </div>

            <div className="relative z-10">
              <div className="flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-8">
                {/* Venstre side: Billede-thumbnail + titel & citatuddrag */}
                <div className="flex items-center gap-4 sm:gap-6 w-full lg:w-auto">
                  <div className="relative w-20 h-20 sm:w-24 sm:h-24 shrink-0 overflow-hidden border border-stone-700/80 shadow-lg">
                    <img
                      src={imageUrl(
                        '/_assets/472331762-1068515591958554-2413136772439242105-n.jpg',
                        'width=300,quality=80,format=auto'
                      )}
                      alt="Smutsten på stranden"
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>

                  <div className="space-y-1 sm:space-y-1.5 min-w-0">
                    <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-[#C4A47C] font-semibold">
                      <i className="fa-solid fa-feather text-[10px]" aria-hidden="true" />
                      <span>Storytelling &bull; Fortællingen bag billedet</span>
                    </div>
                    <h2 className="text-xl sm:text-2xl font-sans font-medium text-white tracking-tight truncate">
                      Smutsten på stranden
                    </h2>
                    <p className="text-stone-300 text-xs sm:text-sm line-clamp-1 italic max-w-xl">
                      »Et billede der ligger op til en fortælling, minder der vækker følelser...«
                    </p>
                  </div>
                </div>

                {/* Højre side: Call to action knapper */}
                <div className="flex items-center gap-3 sm:gap-4 shrink-0 w-full sm:w-auto justify-start sm:justify-end">
                  <Link
                    to="/storytelling"
                    className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-white hover:bg-stone-100 text-[#0C0C0D] font-medium text-xs sm:text-sm tracking-wide transition-colors shadow-md shrink-0"
                  >
                    <span>Læs fortællingen</span>
                    <i className="fa-solid fa-arrow-right text-[11px]" aria-hidden="true" />
                  </Link>
                  <Link
                    to="/kontakt"
                    className="inline-flex items-center justify-center px-4 py-2.5 border border-stone-700 hover:border-stone-500 text-stone-300 hover:text-white font-medium text-xs sm:text-sm tracking-wide transition-colors shrink-0"
                  >
                    Kontakt
                  </Link>
                </div>
              </div>
            </div>
          </section>

          <div className="md:order-2 grid grid-cols-1 md:grid-cols-2 gap-8">
            {categories.map((cat) => (
              <Link
                key={cat.to}
                to={cat.to}
                className="group relative rounded-none overflow-hidden bg-[#141416] transition-all duration-500 flex flex-col justify-end min-h-[420px] p-8 md:p-10 shadow-xl"
              >
                {/* Background image */}
                <div className="absolute inset-0 z-0">
                  <img
                    src={imageUrl(cat.image, 'width=1000,quality=85,format=auto')}
                    alt={cat.title}
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 filter brightness-[0.85]"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/10" />
                </div>

                {/* Content */}
                <div className="relative z-10 space-y-3">
                  <h3 className="text-2xl sm:text-3xl font-medium tracking-tight text-[#F4EFEA] group-hover:text-white transition-colors">
                    {cat.title}
                  </h3>

                  <p className="text-zinc-300 text-sm leading-relaxed max-w-lg">
                    {cat.description}
                  </p>

                  <div className="pt-2 flex items-center gap-2 text-sm font-medium text-white transition-colors">
                    <span>{cat.linkText}</span>
                    <i className="fa-solid fa-arrow-right text-xs transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Galleri med Filtrering */}
      <section className="py-20 md:py-32 bg-white text-[#141416] border-y border-zinc-200" id="galleri">
        <div className="max-w-7xl mx-auto px-6 md:px-8">
          {/* Header */}
          <div className="text-center max-w-2xl mx-auto mb-10 sm:mb-14">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-medium tracking-tight text-[#141416]">
              Udvalgte Værker
            </h2>
            <p className="mt-4 text-zinc-600 text-sm sm:text-base leading-relaxed">
              Gennemse et kurateret udvalg af fotografier og videoer på tværs af bryllupper, sport, events og familier.
            </p>
          </div>

          {/* Filtering buttons */}
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 mb-10 sm:mb-14">
            {filterCategories.map((cat) => {
              const isActive = galleryCategory === cat.key;
              return (
                <button
                  key={cat.key}
                  type="button"
                  onClick={() => setGalleryCategory(cat.key)}
                  className={`px-4 sm:px-5 py-2 sm:py-2.5 text-xs sm:text-sm font-medium tracking-wide transition-all cursor-pointer rounded-none border ${
                    isActive
                      ? 'bg-[#141416] text-white border-[#141416] shadow-sm'
                      : 'bg-white text-zinc-700 hover:text-black hover:border-zinc-400 border-zinc-200'
                  }`}
                >
                  {cat.label}
                </button>
              );
            })}
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 auto-rows-[280px] sm:auto-rows-[320px]">
            {filteredPortfolio.slice(0, 7).map((item, index) => {
              // Asymmetric spans for exactly 7 items
              // In a 3-column grid:
              // Row 1 & 2: Item 0 is 2 cols x 2 rows (occupies cols 1-2, rows 1-2)
              //            Item 1 is 1 col x 1 row (col 3, row 1)
              //            Item 2 is 1 col x 1 row (col 3, row 2)
              // Row 3:     Item 3 is 1 col x 1 row (col 1, row 3)
              //            Item 4 is 2 cols x 1 row (cols 2-3, row 3)
              // Row 4:     Item 5 is 2 cols x 1 row (cols 1-2, row 4)
              //            Item 6 is 1 col x 1 row (col 3, row 4)
              // Total columns per row = 3, perfectly balanced and asymmetric with 0 white gaps!
              const spanClasses = [
                'lg:col-span-2 lg:row-span-2', // Item 1: Stort fremhævet (2x2)
                'lg:col-span-1 lg:row-span-1', // Item 2: (1x1)
                'lg:col-span-1 lg:row-span-1', // Item 3: (1x1)
                'lg:col-span-1 lg:row-span-1', // Item 4: (1x1)
                'lg:col-span-2 lg:row-span-1', // Item 5: Bredt horisontalt (2x1)
                'lg:col-span-2 lg:row-span-1', // Item 6: Bredt horisontalt (2x1)
                'lg:col-span-1 lg:row-span-1', // Item 7: (1x1)
              ][index] || '';

              return (
                <div
                  key={item.id}
                  onClick={() => handleOpenLightbox(index)}
                  className={`group relative overflow-hidden bg-zinc-100 cursor-pointer border border-zinc-200 transition-all duration-300 hover:shadow-xl ${spanClasses}`}
                >
                  <img
                    src={imageUrl(item.image, 'width=1000,quality=85,format=auto')}
                    alt={item.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />

                  {/* Subtly darkened hover overlay without text */}
                  <div className="absolute inset-0 bg-black/15 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
                </div>
              );
            })}
          </div>

          {/* Testimonials placed directly under gallery grid with exact same width and white background */}
          <div className="mt-14 sm:mt-18 pt-10 sm:pt-14 border-t border-zinc-200">
            <TestimonialsSection
              showFilter={false}
              title="Anbefalinger fra vores kunder"
              subtitle="Hør hvad brudepar, familier, forfattere og arrangører siger om samarbejdet med Lunde Media"
              theme="white"
              className="py-0 !bg-white !border-0"
              innerClassName="!px-0 !max-w-none"
            />
          </div>
        </div>
      </section>

      {/* Photographer / About Michael Section (Light Gray Background) */}
      <section className="py-24 md:py-32 bg-[#EAECEF] relative overflow-hidden border-t border-zinc-200">
        {/* Watermark in background */}
        <div className="absolute right-4 sm:right-6 md:right-8 lg:right-12 bottom-0 translate-y-6 sm:translate-y-4 md:translate-y-2 pointer-events-none select-none z-0">
          <img
            src={imageUrl('/_assets/unknown-1-1.png', 'width=800,quality=85,format=auto')}
            alt=""
            aria-hidden="true"
            className="w-36 sm:w-44 md:w-56 lg:w-64 xl:w-72 h-auto object-contain opacity-[0.08] filter grayscale contrast-125"
          />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
            {/* Image (col 1-5) */}
            <div className="lg:col-span-5">
              <div className="relative rounded-none overflow-hidden border border-zinc-300/80 aspect-[4/5] shadow-2xl">
                <img
                  src={imageUrl('/_assets/487214857-1134600378683408-2220849442786892437-n.jpg', 'width=800,quality=85,format=auto')}
                  alt="Michael fra Lunde Media - Fotograf & Videograf"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>

            {/* Text (col 6-12) */}
            <div className="lg:col-span-7 space-y-6">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-medium text-zinc-900 tracking-tight">
                Passion for autentiske relationer og den gode fortælling
              </h2>
              <div className="space-y-4 text-zinc-700 text-sm md:text-base leading-relaxed">
                <p>
                  Jeg har altid været fascineret af de små, ærlige glimt – et blik mellem to mennesker, en spontan latter, rytterens koncentration før start eller den vilde energi til et event.
                </p>
                <p>
                  For mig handler fotografi og video ikke om at opstille perfekte kulisser. Det handler om at skabe tryghed og god stemning, så du og dem omkring dig kan slappe af og være jer selv. Det er dér, magien og de bedste billeder opstår.
                </p>
                <p>
                  Jeg er baseret i Kolding, men tager med glæde ud i hele Danmark for at forevige jeres historier.
                </p>
              </div>

              {/* Badges / Core strengths */}
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 pt-4 border-t border-zinc-300 text-xs text-zinc-600">
                <div className="space-y-1">
                  <div className="text-zinc-900 font-semibold">Både Foto & Video</div>
                  <div>Komplet visuel dækning</div>
                </div>
                <div className="space-y-1">
                  <div className="text-zinc-900 font-semibold">Trygge Rammer</div>
                  <div>Afslappet & nærværende</div>
                </div>
                <div className="space-y-1">
                  <div className="text-zinc-900 font-semibold">Hurtig Levering</div>
                  <div>I højeste trykkvalitet</div>
                </div>
              </div>

              <div className="pt-2">
                <Link
                  to="/kontakt"
                  className="cta-btn inline-flex items-center justify-center px-8 py-4 bg-zinc-900 hover:bg-black text-white font-medium text-sm tracking-wide transition-all shadow-md"
                >
                  Kontakt Michael direkte
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Light Quote / Testimonial & Values Banner */}
      <section className="py-20 md:py-28 bg-[#F3F4F6] text-[#141416] border-t border-zinc-200 text-center">
        <div className="max-w-7xl mx-auto px-6 md:px-8 space-y-6">
          <blockquote className="text-2xl sm:text-3xl md:text-4xl font-sans text-[#141416] leading-snug max-w-4xl mx-auto">
            "Det handler ikke om at dokumentere det, der sker, men om at få dig til at mærke det igen og igen."
          </blockquote>
          <p className="text-xs uppercase tracking-[0.25em] text-[#141416] font-semibold">
            Lunde Media · Foto & Video
          </p>
        </div>
      </section>

      {/* Final Booking Call-to-action Section */}
      <section className="py-24 md:py-32 relative text-center overflow-hidden border-t border-white/10">
        {/* Background Image with subtle dark overlay */}
        <div className="absolute inset-0 z-0">
          <img
            src={imageUrl('/_assets/472331762-1068515591958554-2413136772439242105-n.jpg', 'width=1920,quality=85,format=auto')}
            alt=""
            className="w-full h-full object-cover object-center"
          />
          {/* Subtle dark overlay so the background image is clearly visible while text stays readable */}
          <div className="absolute inset-0 bg-black/40" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 space-y-6">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-white max-w-3xl mx-auto drop-shadow-md">
            Klar til at fortælle din historie?
          </h2>
          <p className="text-stone-100 text-base md:text-lg leading-relaxed max-w-xl mx-auto font-sans drop-shadow-sm font-normal">
            Uanset om du planlægger bryllup, cykelløb, firmaevent eller familiebilleder, tager jeg gerne en uforpligtende snak om dato og ønsker.
          </p>
          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/kontakt"
              className="cta-btn w-full sm:w-auto inline-flex items-center justify-center px-8 py-4 bg-white hover:bg-stone-100 text-[#0C0C0D] font-semibold text-sm tracking-wide transition-all shadow-xl"
            >
              Send en forespørgsel
            </Link>
            <a
              href="tel:26368306"
              className="cta-btn w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent hover:bg-transparent text-white font-medium text-sm tracking-wide transition-all border border-white"
            >
              <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
              <span className="whitespace-nowrap">26 36 83 06</span>
            </a>
          </div>
        </div>
      </section>

      {/* Lightbox for filtered gallery */}
      <Lightbox
        images={filteredPortfolio.map((item) => item.image)}
        currentIndex={lightboxIndex}
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        onNavigate={(nextIdx) => setLightboxIndex(nextIdx)}
      />
    </>
  );
}
